import { settings } from "settings";

const LoginButton = () => {
	const { urls } = settings;

	return (
		<li>
			<a href={urls.login}>Login</a>
		</li>
	);
};

export default LoginButton;
